import { com } from '@eidu/web'
import entityApiUrl from '../baseUrl'
import fetchAuthorized from '../../authorization/fetchAuthorized'
import PatchTypeResponse = com.eidu.sharedlib.entity.api.types.PatchTypeResponse
import serializeToJsonString = com.eidu.sharedlib.entity.util.serializeToJsonString
import PatchTypeRequest = com.eidu.sharedlib.entity.api.types.PatchTypeRequest
import EntityTypeId = com.eidu.sharedlib.entity.type.EntityTypeId

export type PatchEntityTypeParameters = {
  id: EntityTypeId
  patchTypeRequest: PatchTypeRequest
}

const patchEntityType = async ({ id, patchTypeRequest }: PatchEntityTypeParameters): Promise<PatchTypeResponse> => {
  return fetchAuthorized(
    (authContext) => `${entityApiUrl}/organizations/${authContext.organizationId}/types/${id.toString()}`,
    {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: serializeToJsonString(patchTypeRequest),
      method: 'PATCH',
    }
  ).then(async (response) => {
    if (response.status !== 200)
      throw Error(`Unexpected response code ${response.status} from patchEntityType endpoint`)

    return PatchTypeResponse.fromJsonString(await response.text())
  })
}

export default patchEntityType
